import React, { Component } from "react";
import Datas from "../data/blog/home-blog.json";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { Styles } from "./styles/homeBlog.js";
import { Constant, imageDomain } from "../helper/Constants.js";
import axios from "axios";

class HomeBlog extends Component {
  state = {
    secTitle: "Lets See What We Can Show To You Our Useful Blog Article Post.",
    backgroundImage: "testimonials-bg.jpg",
    all_blogs: [],
    loading: true,
    error: null,
  };

  componentDidMount() {
    this.fetchAllBlogs();
  }

  fetchAllBlogs = async () => {
    try {
      const url = Constant?.getUrls?.getAllBlogs;

      if (!url) {
        console.error("Blogs API URL not configured");
        this.setState({ loading: false });
        return;
      }

      const resp = await axios.get(url);
      const blogs = resp?.data?.data;

      if (Array.isArray(blogs)) {
        this.setState({ all_blogs: blogs, loading: false });
      } else {
        this.setState({ loading: false });
      }
    } catch (error) {
      console.error("Failed to fetch blogs:", error);
      this.setState({
        error: error.message || "Failed to fetch",
        loading: false,
      });
    }
  };

  // Resolve image URL properly
  getImageUrl = (poster) => {
    if (!poster) return "";
    if (poster.startsWith("http://") || poster.startsWith("https://"))
      return poster;
    if (process.env.PUBLIC_URL && poster.startsWith("/"))
      return process.env.PUBLIC_URL + poster;
    if (imageDomain) {
      return imageDomain.replace(/\/+$/, "") + "/" + poster.replace(/^\/+/, "");
    }
    return (
      (process.env.PUBLIC_URL || "") +
      (poster.startsWith("/") ? poster : "/" + poster)
    );
  };

  // Build safe link
  getBlogLink = (data) => {
    const slug = data?.slug || data?.id;
    if (!slug) return process.env.PUBLIC_URL || "/";
    return (
      (process.env.PUBLIC_URL || "") +
      (slug.startsWith("/") ? slug : "/" + slug)
    );
  };

  // Format date (3 Mar style)
  formatShortDate = (data) => {
    const possibleFields = [
      "created_at",
      "published_at",
      "createdAt",
      "blogs_date",
      "date",
      "publish_date",
    ];
    let raw = null;
    for (const f of possibleFields) {
      if (data[f]) {
        raw = data[f];
        break;
      }
    }
    if (!raw) return "";
    const d = new Date(raw);
    if (isNaN(d.getTime())) return "";
    const day = d.getDate();
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return `${day} ${monthNames[d.getMonth()]}`;
  };

  // Strip HTML and limit to 200 characters
  getShortContent = (htmlContent) => {
    if (!htmlContent) return "";
    const text = htmlContent.replace(/<[^>]*>?/gm, ""); // remove HTML tags
    return text.length > 200 ? text.substring(0, 200) + "..." : text;
  };

  render() {
    const { all_blogs, loading, error } = this.state;

    return (
      <Styles>
        <section className="home-blog-area">
          <Container>
            <Row>
              <Col md="12">
                <div className="sec-title text-center">
                  <h4>{this.state.secTitle || Datas.secTitle}</h4>
                </div>
              </Col>

              {loading && (
                <Col md="12">
                  <p style={{ textAlign: "center" }}>Loading...</p>
                </Col>
              )}

              {error && (
                <Col md="12">
                  <p style={{ textAlign: "center", color: "red" }}>{error}</p>
                </Col>
              )}

              {!loading && !error && all_blogs.length === 0 && (
                <Col md="12">
                  <p style={{ textAlign: "center" }}>No blogs found.</p>
                </Col>
              )}

              {all_blogs.map((data) => (
                <Col md="6" key={data?.id || data?.slug || Math.random()}>
                  <div className="blog-post">
                    <Row>
                      <Col lg="6" md="12">
                        <div
                          className="blog-img"
                          style={{
                            width: "400px",
                            height: "400px",
                            overflow: "hidden",
                          }}
                        >
                          <Link to={"/blog-details/" + data.slug}>
                            <img
                              src={imageDomain + data?.blogs_poster}
                              alt={data?.blogs_title || "blog poster"}
                              //   className="img-fluid"
                              style={{
                                width: "340px",
                                height: "280px",
                                objectFit: "cover",
                              }}
                            />
                          </Link>
                        </div>
                      </Col>
                      <Col lg="6" md="12">
                        <div className="blog-content">
                          <div className="content-box">
                            <div className="top-content d-flex">
                              <div className="blog-date text-center">
                                <p>3 Mar</p>
                              </div>
                              <div className="blog-title">
                                <h6>
                                  <Link to={this.getBlogLink(data)}>
                                    {data?.blogs_title ||
                                      data?.title ||
                                      "Untitled"}
                                  </Link>
                                </h6>
                              </div>
                            </div>
                            <div className="blog-desk">
                              <p>
                                {this.getShortContent(
                                  data?.blog_content || data?.content
                                )}
                              </p>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
              ))}
              <Col md="12" className="text-center">
                <div className="viewall-btn">
                  <Link to={process.env.PUBLIC_URL + "/blogs"}>
                    View All Blogs
                  </Link>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </Styles>
    );
  }
}

export default HomeBlog;
